import React from 'react'
import styles from './FooterSection.module.css'
import logo from '../../assets/logos/logoDark.svg'

const FooterSection = ({ 
  isActive,
  onBackToTop = () => window.scrollTo({ top: 0, behavior: 'smooth' })
}) => {
  return (
    <div className={`${styles.footerSection} ${isActive ? styles.active : ''}`}>
      <div className={styles.container}>
        <div className={styles.footerContent}>
          <div className={styles.brandSection}>
            <div className={styles.logo}>
              <img src={logo} alt = "로고" draggable={false}/>
            </div>
            
            <div className={styles.tagline}>
              <h3>Draw your mind, heal your heart.</h3>
              <p>
                그림으로 시작하는 마음 치유 플랫폼<br />
                당신의 그림이 담고 있는 의미를 찾아드려<br />
                더 나은 오늘을 만들어가는 여정을 함께합니다.
              </p>
            </div>

            <div className={styles.social}>
              <h4>구독</h4>
              <div className={styles.socialLinks}>
                <a 
                  href="#" 
                  className={styles.socialLink}
                  onClick={(e) => {
                    e.preventDefault();
                    alert('준비중입니다');
                  }}
                >
                  <i className="fab fa-instagram"></i>
                </a>
                <a 
                  href="#" 
                  className={styles.socialLink}
                  onClick={(e) => {
                    e.preventDefault();
                    alert('준비중입니다');
                  }}
                >
                  <i className="fab fa-twitter"></i>
                </a>
                <a 
                  href="#" 
                  className={styles.socialLink}
                  onClick={(e) => {
                    e.preventDefault();
                    alert('준비중입니다');
                  }}
                >
                  <i className="fab fa-facebook"></i>
                </a>
                <a 
                  href="#" 
                  className={styles.socialLink}
                  onClick={(e) => {
                    e.preventDefault();
                    alert('준비중입니다');
                  }}
                >
                  <i className="fab fa-youtube"></i>
                </a>
              </div>
            </div>


          </div>

          <div className={styles.linksSection}>
            <div className={styles.linkGroup}>
              <h4>서비스</h4>
              <ul>
                <li><a href="#">그림분석</a></li>
                <li><a href="#">치료프로그램</a></li>
                <li><a href="#">커뮤니티</a></li>
                <li><a href="#">일기장</a></li>
              </ul>
            </div>

            <div className={styles.linkGroup}>
              <h4>지원</h4>
              <ul>
                <li><a href="#">자주 묻는 질문</a></li>
                <li><a href="#">이용가이드</a></li>
                <li><a href="#">고객센터</a></li>
                <li><a href="#">개인정보처리방침</a></li>
              </ul>
            </div> 

            {/*<div className={styles.newsletter}>
              <h3>뉴스레터</h3>
              <div className={styles.newsletterForm}>
                <input 
                 type="email" 
                 placeholder="이메일 주소를 입력하세요"
                 className={styles.emailInput}
                />
                <button className={styles.subscribeBtn}>
                 Subscribe
                </button>
              </div>
            </div>*/}

          </div>
        </div>

        <div className={styles.footerBottom}>
          <div className={styles.copyright}>
            © 2025 DrawAndYou. All rights reserved.
          </div>
          
          <div className={styles.bottomLinks}>
            <a href="#">이용약관</a>
            <a href="#">개인정보처리방침</a>
            <a href="#">쿠키 정책</a>
          </div>
        </div>

        {/* 상단으로 이동 버튼 */}
        <button 
          className={styles.backToTop}
          onClick={() => onBackToTop()}
        >
          <i className="fas fa-arrow-up"></i>
          <span>처음으로</span>
        </button>
      </div>
    </div>
  )
}

export default FooterSection